import { render, staticRenderFns } from "./VerifyHeader.vue?vue&type=template&id=1e080eee&scoped=true&"
import script from "./VerifyHeader.vue?vue&type=script&lang=js&"
export * from "./VerifyHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e080eee",
  null
  
)

export default component.exports